import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-heading font-bold text-sm">A</span>
              </div>
              <span className="font-heading font-semibold text-foreground-950">AllChinaBuy</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm uppercase tracking-wider">{t("nav.guides")}</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t("nav.spreadsheet")}</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t("valueProp.cards.shipping.title")}</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t("valueProp.cards.qc.title")}</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t("valueProp.cards.safety.title")}</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t("footer.links.about")}</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t("footer.links.privacy")}</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t("footer.links.terms")}</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">{t("footer.links.contact")}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">{t("footer.copyright")}</p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-primary-600 transition-colors">
              <i className="ri-facebook-fill text-lg" />
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-primary-600 transition-colors">
              <i className="ri-twitter-x-fill text-lg" />
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-primary-600 transition-colors">
              <i className="ri-instagram-fill text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}